import { EPermissoes } from '@/enums/ePermissoes';

type MaterialRouteMap = Record<string, any[]>;

const medicaoRoutesByMaterial: MaterialRouteMap = {
  argamassa: [
    {
      description: 'Medição',
      path: 'medicao',
      name: 'paginadomedicaoargamassa',
      component: () => import('@/views/utilidade/medicao/components/GridIndex.vue'),
      meta: {
        tipoFornecimento: 'argamassa',
        utlTipoFornecimentoId: 3,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      path: 'medicao/incluir',
      name: 'medicaoinsertargamassa',
      description: 'Inclusão de Medição de Argamassa',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicaoargamassa',
        tipoFornecimento: 'argamassa',
        utlTipoFornecimentoId: 3,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    },
    {
      description: 'Edição de Medição de Argamassa',
      path: 'medicao/editar/:id',
      name: 'medicaoupdateargamassa',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicaoargamassa',
        tipoFornecimento: 'argamassa',
        utlTipoFornecimentoId: 3,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    }
  ],
  bloco: [
    {
      path: 'medicao',
      name: 'paginadomedicaobloco',
      description: 'Medição',
      component: () => import('@/views/utilidade/medicao/components/GridIndex.vue'),
      meta: {
        tipoFornecimento: 'bloco',
        utlTipoFornecimentoId: 301,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      path: 'medicao/incluir',
      name: 'medicaoinsertbloco',
      description: 'Inclusão de Medição de Bloco',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicaobloco',
        tipoFornecimento: 'bloco',
        utlTipoFornecimentoId: 301,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    },
    {
      path: 'medicao/editar/:id',
      name: 'medicaoupdatebloco',
      description: 'Edição de Medição de Bloco',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicaobloco',
        tipoFornecimento: 'bloco',
        utlTipoFornecimentoId: 301,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    }
  ],
  graute: [
    {
      description: 'Medição',
      path: 'medicao',
      name: 'paginadomedicaograute',
      component: () => import('@/views/utilidade/medicao/components/GridIndex.vue'),
      meta: {
        tipoFornecimento: 'graute',
        utlTipoFornecimentoId: 4,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      path: 'medicao/incluir',
      name: 'medicaoinsertgraute',
      description: 'Inclusão de Medição de Graute',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicaograute',
        tipoFornecimento: 'graute',
        utlTipoFornecimentoId: 4,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    },
    {
      description: 'Edição de Medição de Graute',
      path: 'medicao/editar/:id',
      name: 'medicaoupdategraute',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicaograute',
        tipoFornecimento: 'graute',
        utlTipoFornecimentoId: 4,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    }
  ],
  ceramica: [
    {
      path: 'medicao',
      name: 'paginadomedicaoceramica',
      description: 'Medição',
      component: () => import('@/views/utilidade/medicao/components/GridIndex.vue'),
      meta: {
        tipoFornecimento: 'ceramica',
        utlTipoFornecimentoId: 101,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      path: 'medicao/incluir',
      name: 'medicaoinsertceramica',
      description: 'Inclusão de Medição de Cerâmica',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicaoceramica',
        utlTipoFornecimentoId: 101,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    },
    {
      path: 'medicao/editar/:id',
      name: 'medicaoupdateceramica',
      description: 'Edição de Medição de Cerâmica',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicaoceramica',
        utlTipoFornecimentoId: 101,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    }
  ],
  cabos: [
    {
      path: 'medicao',
      name: 'paginadomedicao',
      description: 'Medição',
      component: () => import('@/views/utilidade/medicao/components/GridIndex.vue'),
      meta: {
        tipoFornecimento: 'cabos',
        utlTipoFornecimentoId: 206,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      path: 'medicao/incluir',
      name: 'medicaoinsertcabos',
      description: 'Inclusão de Medição de Cabos',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicao',
        tipoFornecimento: 'cabos',
        utlTipoFornecimentoId: 206,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    },
    {
      path: 'medicao/editar/:id',
      name: 'medicaoupdatecabos',
      description: 'Edição de Medição de Cabos',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicao',
        tipoFornecimento: 'cabos',
        utlTipoFornecimentoId: 206,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    }
  ],
  concreto: [
    {
      path: 'medicao',
      name: 'paginadomedicaoconcreto',
      description: 'Medição',
      component: () => import('@/views/utilidade/medicao/components/GridIndex.vue'),
      meta: {
        tipoFornecimento: 'concreto',
        utlTipoFornecimentoId: 1,
        permissions: [EPermissoes.Financeiro],
        escopoObra: 'obra'
      },
      goesToMenu: true
    },
    {
      path: 'medicao/incluir',
      name: 'medicaoinsertconcreto',
      description: 'Inclusão de Medição de Concreto',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicaoconcreto',
        tipoFornecimento: 'concreto',
        utlTipoFornecimentoId: 1,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    },
    {
      path: 'medicao/editar/:id',
      name: 'medicaoupdateconcreto',
      description: 'Edição de Medição de Concreto',
      component: () => import('@/views/utilidade/medicao/InclusaoEdicao.vue'),
      meta: {
        parentRouteName: 'paginadomedicaoconcreto',
        tipoFornecimento: 'concreto',
        utlTipoFornecimentoId: 1,
        permissions: [EPermissoes.Financeiro]
      },
      goesToMenu: false
    }
  ]
};

export default medicaoRoutesByMaterial;
